import { Injectable } from '@angular/core';
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({
  providedIn: 'root'
})
export class CustomSnackbarService {

  constructor(public snackBar: MatSnackBar) { }

  // open(message: string, action: string, css) {
  //   this.snackBar.open(message, action, {
  //     duration: 2500,
  //     verticalPosition: 'bottom',
  //     horizontalPosition: 'center',
  //     panelClass: [css],
  //   });
  // }

  open(message: string, action: string, panelClass) {
    this.snackBar.open(message, action, {
      duration: 2500,
      verticalPosition: 'bottom',
      horizontalPosition: 'center',
      panelClass: [panelClass]
    });
  }
}
